export default "__VITE_ASSET__D1y3HHyc__"